import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
interface EmptySectionProps {
  mainMessage: string;
  subMessage?: string;
  actionButton?: {
    text: string;
    onClick: VoidFunction;
  };
}
export const EmptySection = t0 => {
  const $ = _c(10);
  const {
    mainMessage,
    subMessage,
    actionButton
  } = t0;
  let t1;
  if ($[0] !== mainMessage) {
    t1 = <strong className="font-500 text-Gray-700 typo-body3">{mainMessage}</strong>;
    $[0] = mainMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subMessage) {
    t2 = subMessage ? <p className="whitespace-pre-wrap font-400 text-Gray-600 typo-body4">{subMessage}</p> : null;
    $[2] = subMessage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== actionButton) {
    t3 = actionButton ? <Button className="mt-24 w-full" roundness="capsule" onClick={actionButton.onClick}>{actionButton.text}</Button> : null;
    $[4] = actionButton;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <section className="flex-col break-keep px-20 py-150 text-center flex-center">{t1}{t2}{t3}</section>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};